import React, { useEffect } from 'react'
import classes from './Footer.module.css'
import Path from '../../img/path__bottom.png'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = (props) => {

  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
    <footer>
        <img src={Path} alt="Dolny wzór" title="Dolny wzór" className={classes.square__footer}/>
        <section className={classes.footer}>
            <div className={classes.brand}>
                &#169; 2025 Indigo Nails.
            </div>
            <div className={classes.privacy}>
                <a
                className={classes.privacyLink}
                target="_blank"
                title="Policy privacy"
                href="https://www.indigo-nails.com/en/privacy-policy-and-cookie-policy">
                {props.onTranslate('privacy__link')}
                </a>
            </div>
        </section>
    </footer>
  )
}

export default Footer;